import { ScrollText } from "lucide-react";


const Certificates = () => {
  const certificates = [
    {
      id: 1,
      title: "GST Certificate of Registration",
      description:
        "This certificate is awarded to recognize the registration of the entity under the Goods and Services Tax (GST) regime, as mandated by the Government of India.",
      image: require("../assets/gst_logo.png"),
      pdf: "/pdfs/gst_certificate.pdf", // ✅ starts with /
    },
    {
      id: 2,
      title: "Import Export Code (IEC) Certificate",
      description:
        "The Import Export Code (IEC) is a unique 10-digit code issued by the Directorate General of Foreign Trade (DGFT), Government of India. It is mandatory for any entity engaged in the import or export of goods and services.",
      image: require("../assets/importexportcode.png"),
      pdf: "/pdfs/certificateOfIEC.pdf",
    },
    {
      id: 3,
      title: "Udyami Certificate",
      description:
        "The Udyami Certificate is issued by the Ministry of Micro, Small and Medium Enterprises (MSME), Government of India, to promote and support small businesses and entrepreneurs.",
      image: require("../assets/udyami.png"),
      pdf: "/pdfs/udyami_register.pdf",
    },
    {
      id: 4,
      title: "MSME Registration Certificate",
      description:
        "The MSME Registration Certificate is issued by the Ministry of Micro, Small and Medium Enterprises, Government of India, providing official recognition to micro, small, and medium enterprises, enabling them to avail benefits and schemes offered by the government.",
      image: require("../assets/msme.jpeg"),
      pdf: "/pdfs/msme_certificate.pdf",
    },
    {
      id: 5,
      title: "APEDA Registration Certificate",
      description:
        "The Agricultural and Processed Food Products Export Development Authority (APEDA) Registration Certificate is issued by the Government of India to exporters of agricultural and processed food products, allowing them to participate in export promotion schemes and global trade opportunities.",
      image: require("../assets/apeda.jpeg"),
      pdf: "/pdfs/apeda_certificate.pdf",
    },
    {
      id: 6,
      title: "Coir Board Registration Certificate",
      description:
        "The Coir Board Registration Certificate is issued by the Coir Board under the Ministry of MSME, Government of India. It recognizes manufacturers and exporters dealing in coir and coir-based products, supporting them with training, subsidies, and export assistance.",
      image: require("../assets/Cori.webp"),
      pdf: "/pdfs/coirboard_certificate.pdf",
    }

  ];

  return (
    <main className="min-h-screen bg-[#FFF3D6]">
      {/* Hero Section */}
      <div className="relative h-[40vh] bg-[#B08968] flex items-center justify-center text-center px-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-xl md:text-2xl mb-4 text-dark mt-20">
            Authenticated by industry experts: Our certifications ensure the
            authenticity, quality, and compliance of our cocopeat and coir
            products, organic fertilizers, bagasse tableware, and natural
            powders like Multani mitti and neem—guaranteeing trust and
            excellence in every export.
          </h1>
          <button className="bg-[#5C3D2E] text-white px-6 py-2 rounded hover:bg-[#4A3228] transition-colors">
            OUR CERTIFICATE
          </button>
        </div>
      </div>

      {/* Recognized Certificate Section */}
      <div className="max-w-7xl mx-auto px-4 py-20">
        <h2 className="text-4xl md:text-5xl font-serif text-center mb-8">
          Recognized Certificate
        </h2>
        <p className="text-center text-gray-700 max-w-4xl mx-auto mb-16 text-lg font-inter">
          Explore our range of certifications that validate our commitment to
          quality, sustainability, and global compliance in the export of
          eco-friendly products. From cocopeat and coir-based goods to organic
          fertilizers, bagasse tableware, and natural powders like Multani mitti
          and neem, each certification reflects our dedication to maintaining
          high standards and promoting environmentally responsible trade
          worldwide.{" "}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {certificates.map((cert) => (
            <div
              key={cert.id}
              className="bg-white rounded-lg shadow-lg p-6 text-center"
            >
              <div className="h-48 relative mb-6">
                <img
                  src={cert.image}
                  alt={cert.title}
                  className="object-contain w-full h-full"
                  style={{ objectFit: "contain" }}
                />
              </div>
              <h3 className="text-2xl font-serif mb-4">{cert.title}</h3>
              <p className="text-gray-600 mb-6">{cert.description}</p>
              {/* <Link
                to="#"
                className="inline-flex items-center text-[#5C3D2E] hover:text-[#4A3228] border-2 border-[#5C3D2E] px-6 py-2 rounded transition-colors"
              >
                <ScrollText className="mr-2" />
                View Certificate
              </Link> */}
              {/* <a
                href={cert.pdf}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-[#5C3D2E] hover:text-[#4A3228] border-2 border-[#5C3D2E] px-6 py-2 rounded transition-colors"
              >
                <ScrollText className="mr-2" />
                View Certificate
              </a> */}
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default Certificates;
